import React from 'react';
import Icon from '../AppIcon';

const ProgressHeader = ({ 
  currentStep = 1, 
  totalSteps = 3, 
  currentStepTitle = "Welcome",
  completionPercentage = 33 
}) => {
  const steps = [
    { id: 1, title: "Welcome", path: "/assessment-welcome-introduction" },
    { id: 2, title: "Assessment", path: "/multi-step-assessment-form" },
    { id: 3, title: "Results", path: "/assessment-results-recommendations" }
  ];

  const getStepStatus = (stepId) => {
    if (stepId < currentStep) return 'completed';
    if (stepId === currentStep) return 'current';
    return 'upcoming';
  };

  return (
    <div className="fixed top-0 left-0 right-0 bg-surface border-b border-border z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Brand Header */}
        <div className="flex items-center justify-between py-8">
          <div className="flex items-center space-x-3">
            <img src="public/assets/images/apollo-logo-new.png" className="flex items-center justify-center w-17 h-12"></img>
            <div>
              <h1 className="text-xl font-heading font-semibold text-text-primary">
                Wellness and Anxiety Evaluation
              </h1>
              <p className="text-sm font-caption text-text-secondary"></p>
            </div>
          </div>
          
          {/* Session Controls */}
          <div className="flex items-center space-x-3">
            <button className="p-2 text-text-secondary hover:text-text-primary transition-colors duration-150">
              <Icon name="HelpCircle" size={20} />
            </button>
            <button className="p-2 text-text-secondary hover:text-text-primary transition-colors duration-150">
              <Icon name="Save" size={20} />
            </button>
          </div>
        </div>

        {/* Progress Section */}
        <div className="pb-4">
          {/* Progress Bar */}
          <div className="mb-4">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-medium text-text-primary">
                Step {currentStep} of {totalSteps}: {currentStepTitle}
              </span>
              <span className="text-sm text-text-secondary">
                {completionPercentage}% Complete
              </span>
            </div>
            <div className="progress-indicator">
              <div 
                className="progress-bar" 
                style={{ width: `${completionPercentage}%` }}
              />
            </div>
          </div>

          {/* Step Indicators - Desktop */}
          <div className="hidden md:flex items-center justify-between">
            {steps.map((step, index) => {
              const status = getStepStatus(step.id);
              return (
                <div key={step.id} className="flex items-center">
                  <div className="flex items-center">
                    <div className={`
                      flex items-center justify-center w-8 h-8 rounded-full border-2 transition-all duration-200
                      ${status === 'completed' 
                        ? 'bg-success border-success text-white' 
                        : status === 'current' ?'bg-primary border-primary text-white' :'bg-surface border-border text-text-secondary'
                      }
                    `}>
                      {status === 'completed' ? (
                        <Icon name="Check" size={16} />
                      ) : (
                        <span className="text-sm font-medium">{step.id}</span>
                      )}
                    </div>
                    <span className={`
                      ml-3 text-sm font-medium
                      ${status === 'current' ?'text-text-primary' 
                        : status === 'completed' ?'text-success' :'text-text-secondary'
                      }
                    `}>
                      {step.title}
                    </span>
                  </div>
                  {index < steps.length - 1 && (
                    <div className={`
                      flex-1 h-0.5 mx-4 transition-colors duration-200
                      ${step.id < currentStep ? 'bg-success' : 'bg-border'}
                    `} />
                  )}
                </div>
              );
            })}
          </div>

          {/* Step Indicators - Mobile */}
          <div className="md:hidden flex items-center justify-center space-x-2">
            {steps.map((step) => {
              const status = getStepStatus(step.id);
              return (
                <div key={step.id} className={`
                  w-3 h-3 rounded-full transition-all duration-200
                  ${status === 'completed' 
                    ? 'bg-success' 
                    : status === 'current' ?'bg-primary' :'bg-border'
                  }
                `} />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressHeader;